@if ({
user: user$ | async
}; as vm) {
  <app-modal-shell [showFooter]="true"
    [dismissLabel]="'general.close' | translate"
    (dismiss)="dismiss()">
    <div modalTitle>
      <h2>{{ 'templates.ticketTemplate' | translate }}</h2>
    </div>
    <form class="default-template-modal"
      [formGroup]="formGroup"
      (ngSubmit)="save()">
      @if (vm.user?.role === 'super-admin') {
        @if (businessTypes$ | async; as businessTypes) {
          <button class="default-template-modal__select-button"
            type="button"
            (click)="selectBusinessType(businessTypes)">
            @if (formGroup.get('name').value) {
              {{ formGroup.get('name').value }}
            } @else {
              {{ 'signup.businessType' | translate }}
            }
          </button>
        }
      } @else {
        <div class="default-template-modal__field">
          <label class="default-template-modal__label">{{ 'templates.name' | translate }}</label>
          <input class="default-template-modal__input"
            autocapitalize="on"
            formControlName="name" />
        </div>
      }

      <div class="default-template-modal__field"
        formGroupName="estimate">
        <label
          class="default-template-modal__label">{{ 'managerTasks.fields.durationEstimateMinutes' | translate }}</label>
        <div class="default-template-modal__estimate-row">
          <input class="default-template-modal__input"
            type="number"
            formControlName="quantity"
            [placeholder]="'templates.estimate.quantity' | translate" />
          <input class="default-template-modal__input"
            type="text"
            formControlName="unit"
            [placeholder]="'templates.estimate.unit' | translate" />
          <input class="default-template-modal__input"
            type="number"
            formControlName="minutes"
            [placeholder]="'templates.estimate.minutes' | translate" />
        </div>
      </div>

      <div class="default-template-modal__field">
        <label class="default-template-modal__label">{{ 'templates.form.executeInstructions' | translate }}</label>
        <textarea class="default-template-modal__textarea"
          rows="6"
          formControlName="instructionExecuteText"></textarea>
      </div>

      <div class="default-template-modal__field default-template-modal__media">
        <label class="default-template-modal__label">{{ 'templates.form.executeInstructions' | translate }} ·
          {{ 'workerUi.taskDetail.attachments' | translate }}</label>
        <app-pick-media [name]="'default-template-instruction-' + (formGroup.get('guid').value ?? 'new')"
          [items]="[]"
          (filesSelected)="onInstructionFilesSelected($event)"></app-pick-media>

        @if (instructionImagesS().length > 0) {
          <div class="default-template-modal__media-list">
            @for (image of instructionImagesS(); track image) {
              <div class="default-template-modal__media-item">
                <a [href]="image"
                  target="_blank"
                  rel="noreferrer">{{ image }}</a>
                <button type="button"
                  (click)="removeInstructionImage(image)">{{ 'general.delete' | translate }}</button>
              </div>
            }
          </div>
        }

        @if (instructionVideoS()) {
          <div class="default-template-modal__media-list">
            <div class="default-template-modal__media-item">
              <a [href]="instructionVideoS()"
                target="_blank"
                rel="noreferrer">{{ instructionVideoS() }}</a>
              <button type="button"
                (click)="removeInstructionVideo()">{{ 'general.delete' | translate }}</button>
            </div>
          </div>
        }
      </div>

      <div class="default-template-modal__field-header">
        <label class="default-template-modal__label">{{ 'templates.addItem' | translate }}</label>
        <button class="default-template-modal__add-button"
          type="button"
          (click)="addItem()">{{ 'templates.addItem' | translate }}</button>
      </div>
      <div formArrayName="fields">
        @for (item of fieldsArray.controls; track item; let i = $index) {
          <div class="default-template-modal__field-row">
            <input class="default-template-modal__input"
              autocapitalize="on"
              [formControlName]="i"
              [placeholder]="'templates.example' | translate" />
            <button class="default-template-modal__remove"
              type="button"
              (click)="deleteItem(i)">
              {{ 'general.delete' | translate }}
            </button>
          </div>
        }
      </div>
    </form>

    <div modalFooter>
      <button class="default-template-modal__button default-template-modal__button--secondary"
        type="button"
        (click)="translateAgain()">
        {{ 'general.translate' | translate }}
      </button>
      <button class="default-template-modal__button default-template-modal__button--secondary"
        type="button"
        (click)="dismiss()">
        {{ 'general.cancel' | translate }}
      </button>
      <button class="default-template-modal__button default-template-modal__button--primary"
        type="button"
        [disabled]="!formGroup.valid"
        (click)="save()">
        {{ 'general.save' | translate }}
      </button>
    </div>
  </app-modal-shell>
}